module.exports = __webpack_public_path__ + "img/tianqin4en.6ce46243.jpg";